'use strict';

const EventModel = require('../models/event');
const BaseCollection = require('./base');

class EventsCollection extends BaseCollection {
  initialize() {
    this.model = EventModel;
  }

  times() {
    return this.map(event => event.getTime());
  }
}

module.exports = EventsCollection;
